export default function TargetFieldImage({
    onDragOver,
    onDrop,
    left,
    top,
    background,
    width,
    height,
}) {
    return (
        <div
            className="type5-answerField"
            onDragOver={onDragOver}
            onDrop={onDrop}
            style={{
                width: width,
                height: height,
                left: left,
                top: top,
                background: background,
            }}>
            <div className="type5-answer"></div>
        </div>
    );
}
